import { render, staticRenderFns } from "./CustomColorNew.vue?vue&type=template&id=418262c0&scoped=true&"
import script from "./CustomColorNew.vue?vue&type=script&lang=js&"
export * from "./CustomColorNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomColorNew.vue?vue&type=style&index=0&id=418262c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418262c0",
  null
  
)

export default component.exports